<template>
    <div>
        <!-- Modal Datas Glosa -->
        <div class="modal fade" id="retornoDatasGlosa" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Datas Glosadas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="guia && proc">
                            <strong>Paciente:</strong> {{ guia.guia.atendimento.paciente.st_nome }} <br>
                            <strong>Guia:</strong> {{ guia.guia.guia_formatada }} <br>
                            <template v-if="guia.guia.data_guia">
                                <strong>Data:</strong> {{ $util.getFormatDate(guia.guia.data_guia) }} <br>
                            </template>
                            <strong>Procedimento:</strong> {{ proc.item_tabela.search }} <br>
                            <template v-if="proc.retorno">
                                <strong>Valor Glosado:</strong> {{ $util.formatMoeda(proc.retorno.dc_valor_glosa) }}
                            </template>
                        </div>

                        <div class="alert alert-warning" v-if="msg">
                            <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                            {{ msg }}
                        </div>

                        <div class="form-row mb-2" v-if="proc && proc.retorno">
                            <div class="col col-12">
                                <az-input
                                    label="Quantidade"
                                    :compact="true"
                                    type="number"
                                    placeholder="Não Informada..."
                                    v-model="proc.retorno.in_quantidade" />
                            </div>
                        </div>

                        <az-sub-title title="Datas Glosadas" v-if="proc">
                            <div v-if="total_identificado" :class="total_identificado == proc.retorno.dc_valor_glosa ? 'text-success' : 'text-danger'">
                                {{ $util.formatMoeda(total_identificado) }}
                            </div>
                        </az-sub-title>
                        <div class="mb-3" v-if="!lista_datas.length">Nenhuma data selecionada.</div>
                        <ul class="list-group mb-3" v-else>
                            <li class="list-group-item d-flex justify-content-between" v-for="(item, index) in lista_datas" :key="index">
                                <div>{{ $util.getFormatDate(item.data) }}</div>
                                <div>
                                    {{ $util.formatMoeda(item.glosado) }}
                                    <a href="#" @click.prevent="remover_data(item)" class="ml-3">
                                        <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </li>
                        </ul>

                        <template v-if="lista_atps && lista_atps.length > 0">
                            <az-sub-title title="Datas Atendidas"></az-sub-title>
                            <div class="list-group mb-3">
                                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" 
                                    :class="{'list-group-item-danger': teste_data_glosada(atp.dt_execucao ? atp.dt_execucao : atp.atendimento.dt_inicio)}"
                                    v-for="(atp, iax) in lista_atps" :key="iax" @click="selecionar_data(atp)">
                                    <div>
                                        <div>{{ $util.getFormatDate(atp.dt_execucao ? atp.dt_execucao : atp.atendimento.dt_inicio) }}</div>
                                        <div class="small">#{{ atp.id_atendimento }}</div>
                                    </div>
                                    <div class="text-right">
                                        <div>{{ atp.procedimento.st_procedimento }}</div>
                                        <div class="small text-muted">{{ atp.atendimento.medico.st_nome_exibicao }}</div>
                                    </div>
                                </button>
                            </div>
                        </template>

                        <template v-else-if="proc && proc.retorno && proc.retorno.in_quantidade > 1">
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input sizing="sm" type="date" v-model="nova_data">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button type="button" class="btn btn-sm btn-outline-primary" :disabled="!nova_data" @click="selecionar_data_avulso()">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="(guia.guia && guia.guia.data_guia)">
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="selecionar_data_avulso(guia.guia.data_guia)">
                                                    <i class="fa fa-plus mr-1" aria-hidden="true"></i> {{ $util.getFormatDate(guia.guia.data_guia) }}
                                                </button>
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="selecionar_data_avulso(guia.guia.data_guia, proc.retorno.in_quantidade - lista_datas.length)" v-if="lista_datas && ( proc.retorno.in_quantidade > lista_datas.length )">
                                                    x{{ proc.retorno.in_quantidade - lista_datas.length }}
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>
                        </template>

                        <template v-if="arquivo_retorno">
                            <az-sub-title title="Arquivo de Retorno"></az-sub-title>
                            <div class="list-group">
                                <a :href="arq.arquivo.temporary_url" class="list-group-item list-group-item-action" v-for="(arq, iax) in arquivo_retorno.arquivos" :key="iax" target="_blank">
                                    {{ arq.arquivo.st_titulo }}
                                </a>
                            </div>
                        </template>

                        <pre v-if="false">{{ lista_atps }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            proc: null, 
            guia: null,
            lista_atps: null, 
            proc_original: null,
            arquivo_retorno: null, 
            msg: "", 
            nova_data: "", 
        }       
    },

    components: { 
        AzSubTitle,
        AzSubmit,
        AzInput, 
    },

    computed: {
        lista_datas: function () { 
            if ( !this.proc || !this.proc.retorno || !this.proc.retorno.js_datas ) { 
                return [];
            }

            return this.proc.retorno.js_datas.filter(item => item.glosado > 0)
        },

        total_identificado: function () { 
            if ( !this.proc || !this.proc.retorno || !this.proc.retorno.js_datas ) { 
                return 0;
            }

            return _.sumBy(this.proc.retorno.js_datas.filter(item => item.glosado > 0), item => parseFloat(item.glosado));
        }
    },

    methods: { 
        selecionar_data_avulso (data = null, qtde = 1) { 
            if ( !data ) { 
                data = this.nova_data;
            }

            if ( !data ) { 
                return; 
            }

            for(let i = 0; i < qtde; i++ ) {
                this.selecionar_data({ 
                        dt_execucao: data,
                    },
                    true
                );
            }
        },

        teste_data_glosada (data) { 
            if ( data && this.lista_datas && this.lista_datas.length > 0 ) { 
                let achou = this.lista_datas.find(item => item.data === data.slice(0,10));
                if ( achou ) { 
                    return true;
                }
            }

            return false;
        },
        remover_data (item) {
            if (this.proc && this.proc.retorno && this.proc.retorno.js_datas) {
                let index = this.proc.retorno.js_datas.findIndex(i => i && ( i.data === item.data ));
                if (index !== -1) {
                    this.proc.retorno.js_datas.splice(index, 1);
                }
            }
        },

        selecionar_data (atp, force_incluir = false) { 
            if ( this.proc && this.proc.retorno ) { 
                if ( !this.proc.retorno.js_datas ) { 
                    this.proc.retorno.js_datas = [];
                }

                let data = atp.dt_execucao ? atp.dt_execucao : atp.atendimento.dt_inicio;

                if ( force_incluir || !this.teste_data_glosada(data) ) { 
                    this.proc.retorno.js_datas.push({
                        data: data.slice(0,10),
                        glosado: parseFloat(this.proc.dc_valor),
                    });
                } else { 
                    let idd = this.proc.retorno.js_datas.findIndex(item => item.data === data.slice(0,10));

                    if ( idd >= 0 ) { 
                        this.proc.retorno.js_datas.splice(idd, 1);
                    }
                }
            }
        },

        abrir(proc, guia) {
            this.lista_atps = null; 
            this.arquivo_retorno = null; 
            this.guia = guia;
            this.proc_original = proc;
            this.proc = _.cloneDeep(proc);
            

            this.$util.load(this, { 
                service: 'faturas', 
                func: 'get_datas_pacote_sessao',
                parms: { 
                    id_atendimento_procedimento_guia: proc.id_atendimento_procedimento_guia, 
                    id_arquivo_retorno: proc.retorno ? proc.retorno.id_arquivo_retorno : null,
                },
                loadTo: res => { 
                    this.lista_atps = res.atps;
                    this.arquivo_retorno = res.arquivo_retorno;
                    this.msg = res.msg;
                }
            });

            $('#retornoDatasGlosa').modal('show');
        },

        atualizar () { 
            if ( this.proc && this.proc.retorno ) { 
                this.$util.atualizar(this, { 
                    service: 'faturas', 
                    func: 'set_datas_glosa_pacote_sessao',
                    dados: { 
                        id_retorno_fatura: this.proc.retorno.id_retorno_fatura,
                        in_quantidade: this.proc.retorno.in_quantidade, 
                        js_datas: this.lista_datas, 
                    },
                    modal: 'retornoDatasGlosa',
                    toast: true, 
                    callback: res => { 
                        if ( res && res.retorno && res.retorno.js_datas ) { 
                            this.proc_original.retorno.js_datas = res.retorno.js_datas;
                        }

                        if ( res && res.retorno && res.retorno.in_quantidade ) { 
                            this.proc_original.retorno.in_quantidade = res.retorno.in_quantidade;
                        }
                    }
                });
            }
        }
    },
}
</script>
